// src/infra/api/templateApi.js
import axiosInstance from '../axios';

// lista (sem contentHtml)
export const listTemplates = async ({ q, status }) => {
    const params = {};
    if (q) params.q = q;
    if (status && status !== 'all') params.status = status.toUpperCase();
    const { data } = await axiosInstance.get('/templates', { params });
    return data;
};

export const createTemplate = async (payload) => {
    const { data } = await axiosInstance.post('/templates', payload);
    return data;
};

export const updateTemplate = async (id, payload) => {
    const { data } = await axiosInstance.put(`/templates/${id}`, payload);
    return data;
};

export const deleteTemplate = async (id) => {
    await axiosInstance.delete(`/templates/${id}`);
    return true;
};

export const duplicateTemplate = async (id) => {
    const { data } = await axiosInstance.post(`/templates/${id}/duplicate`);
    return data;
};

// 👇 editor
export const getTemplate = async (id) => {
    const { data } = await axiosInstance.get(`/templates/${id}`); // vem com contentHtml
    return data;
};

export const updateTemplateContent = async (id, contentHtml) => {
    const { data } = await axiosInstance.put(`/templates/${id}/content`, { contentHtml });
    return data;
};
